module.exports = __webpack_public_path__ + "static/media/slide04_image.dd116b76.png";